import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import QrCode2Icon from '@mui/icons-material/QrCode2';

/**
 * InfluencerSocialButtons
 * Single reusable button row used by EVERY influencer card.
 * All dimensions are owned by CSS class .isb-btn — never inline.
 * This guarantees pixel-identical buttons across all cards and pages.
 */
function InfluencerSocialButtons({ contact_number, facebook_link, instagram_link, youtube_link, name }) {
  return (
    <div className="isb-row">
      <div className="isb-buttons">
        {contact_number && (
          <a href={`tel:${contact_number}`} className="isb-btn isb-contact" title="Contact">
            <PhoneIcon className="isb-icon" />
          </a>
        )}
        {facebook_link && (
          <a href={facebook_link} target="_blank" rel="noreferrer" className="isb-btn isb-fb" title="Facebook">
            <FacebookIcon className="isb-icon" />
          </a>
        )}
        {instagram_link && (
          <a href={instagram_link} target="_blank" rel="noreferrer" className="isb-btn isb-ig" title="Instagram">
            <InstagramIcon className="isb-icon" />
          </a>
        )}
        {youtube_link && (
          <a href={youtube_link} target="_blank" rel="noreferrer" className="isb-btn isb-yt" title="YouTube">
            <YouTubeIcon className="isb-icon" />
          </a>
        )}
      </div>
      <div className="isb-qr" title={name ? `QR: ${name}` : 'QR Code'}>
        <QrCode2Icon className="isb-qr-icon" />
      </div>
    </div>
  );
}

export default InfluencerSocialButtons;
